module.exports = __webpack_public_path__ + "static/media/teacher_view_place_video.c6fa1b00.mov";